module.exports = __webpack_public_path__ + "static/media/phone.0162b2ed.svg";